import { useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const KEY = "lm_cookie_consent";

const initialShow = () => {
  try {
    return !localStorage.getItem(KEY);
  } catch {
    return true;
  }
};

export const CookieConsent = () => {
  const [show, setShow] = useState(initialShow);

  const persist = (value) => {
    try {
      localStorage.setItem(KEY, value);
      document.cookie = `${KEY}=${value}; path=/; max-age=${60 * 60 * 24 * 365}; samesite=lax`;
    } catch {
      // ignore
    }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Obavijest o kolačićima"
      data-testid="cookie-consent"
      className="fixed inset-x-3 bottom-3 md:bottom-5 md:left-5 md:right-auto z-50 max-w-md bg-[#061A12] border border-gold/30 grain"
    >
      <div className="relative p-5 md:p-6">
        <button
          onClick={() => persist("dismissed")}
          aria-label="Zatvori"
          data-testid="cookie-close"
          className="absolute top-3 right-3 text-[#B0C4B1] hover:text-gold transition"
        >
          <X className="w-4 h-4" strokeWidth={1.5} />
        </button>

        <p className="font-sans tracking-luxury text-[0.6rem] uppercase text-gold/80">Kolačići</p>
        <h3 className="mt-2 font-serif text-xl text-[#F5EFE3] leading-tight">Koristimo samo nužne kolačiće.</h3>
        <p className="mt-3 font-sans text-xs text-[#B0C4B1] leading-relaxed">
          Stranica koristi isključivo tehničke kolačiće potrebne za rad (npr. admin prijava i ova obavijest).
          Ne pratimo Vas, ne koristimo analitiku ni marketinške kolačiće.{" "}
          <Link to="/kolacici" className="text-gold hover:underline">Više o kolačićima</Link>.
        </p>

        <div className="mt-5 flex items-center gap-3">
          <button
            onClick={() => persist("accepted")}
            data-testid="cookie-accept"
            className="btn-luxury btn-luxury-solid !py-2.5 !px-5 !text-[0.65rem]"
          >
            U redu, prihvaćam
          </button>
          <Link
            to="/pravila-privatnosti"
            data-testid="cookie-privacy-link"
            className="font-sans tracking-luxury text-[0.6rem] uppercase text-[#B0C4B1] hover:text-gold transition"
          >
            Privatnost
          </Link>
        </div>
      </div>
    </div>
  );
};
